<div *ngIf="error" class="page gap-5 d-flex flex-column justify-content-center align-items-center text-center h-100">

    <h2 class="fs-1" color="primary" translate>{{ error.title }}</h2>

    <img [src]="error.img" style="width: 50%; min-width: 150px; max-width: 400px;" alt="Error">

    <p *ngIf="error.description" class="fs-4" translate>{{error.description}}</p>
    <p *ngIf="error.redirectUrl" translate="title.label.redirect.error"></p>
</div>
